import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type Table } from '@tanstack/table-core';
    import { Checkbox } from '@/components/ui/checkbox';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableThCheckbox',
  props: {
    table: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Checkbox), {
    "model-value": 
            _ctx.table.getIsSomePageRowsSelected() ? 'indeterminate' : _ctx.table.getIsAllPageRowsSelected()
        ,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.table.toggleAllPageRowsSelected(!!value)),
    "aria-label": "Select all"
  }, null, 8, ["model-value"]))
}
}

})